import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { server } from "../../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

// const initialValues = {
//   name: "",
//   contactno: "",
//   email: "",
//   college_name: "",
//   education: "",
//   year: "",
// };

const EditShopDetails = () => {
  const user = useSelectAccess("Merchant");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      shop_name: "",
      owner: "",
      mobile: "",
      email: "",
      details: "",
      address: "",
      landmark: "",
      city: "",
      pincode: "",
      location: "",
      url1: "",
      category: "",
      timing: "",
    },
    validationSchema: yup.object({
      // ... your validation schema here ...
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        const response = await server.put(
          "/shopdetails/updateshopdetails",
          values,
          {
            headers: {
              Authorization: user.authToken,
            },
          }
        );
        toast.success(" updated successfully");
        navigate("/merchantprofile/addbusiness");
      } catch (error) {
        if (error instanceof AxiosError && error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else {
          toast.error("Failed to update profile");
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await server.get("/shopdetails/getshopdetails", {
          headers: {
            Authorization: user.authToken,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        console.log("Fetched data:", response.data);

        // Assuming the array has only one item, use it to set form values
        const firstItem = response.data[0];
        if (firstItem) {
          formik.setValues(firstItem);
        }
      } catch (error) {
        if (error.response?.status === 401) {
          navigate("/loginmerchant");
        }
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [navigate, user.authToken, formik.setValues]);

  return (
    <div>
      <section>
        <div className="container-xl mb-5">
          <form
            className="needs-validation d-flex flex-column gap-2"
            onSubmit={formik.handleSubmit}
          >
            <div className="">
              <h5 className="mb-3">Business Details</h5>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <TextField
                    name="shop_name"
                    //   margin="dense"
                    type="text"
                    value={formik.values.shop_name}
                    onChange={formik.handleChange}
                    placeholder="Shop Name"
                    variant="outlined"
                    label="Business Name"
                    fullWidth
                    required
                  ></TextField>
                </div>

                <div className="col-md-6  mb-3">
                  <TextField
                    name="owner"
                    //   margin="dense"
                    type="text"
                    value={formik.values.owner}
                    onChange={formik.handleChange}
                    placeholder="Owner's Full Name"
                    variant="outlined"
                    label="Owner"
                    fullWidth
                    required
                  ></TextField>
                </div>
              </div>
              <div className="row  mb-3">
                <div className="col-md-6">
                  <TextField
                    name="mobile"
                    //   margin="dense"
                    type="number"
                    value={formik.values.mobile}
                    onChange={formik.handleChange}
                    // disabled={!!props.edit}

                    placeholder="Mobile Number"
                    variant="outlined"
                    label="Business Mobile Number"
                    fullWidth
                    disabled
                    required
                  ></TextField>
                </div>

                <div className="col-md-6">
                  <TextField
                    name="email"
                    //   margin="dense"
                    type="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    placeholder="Business Email"
                    variant="outlined"
                    label="Business Email"
                    disabled
                    fullWidth
                    required
                  ></TextField>
                </div>
              </div>
              <div className=" mb-3">
                <TextField
                  name="details"
                  // margin="dense"
                  type="text"
                  value={formik.values.details}
                  onChange={formik.handleChange}
                  placeholder="Describe your business (min 200 chars)"
                  variant="outlined"
                  label="Business Details"
                  fullWidth
                  multiline
                  minRows={3}
                  required
                ></TextField>
              </div>
            </div>

            <div>
              <h5 className="mb-3">Address Details</h5>
              <div>
                <div className="row  mb-3">
                  <div className="col-md-6">
                    <TextField
                      name="address"
                      type="text"
                      //   margin="dense"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      placeholder="Address"
                      variant="outlined"
                      label="Address"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                  <div className="col-md-6">
                    <TextField
                      name="landmark"
                      type="text"
                      //   margin="dense"
                      value={formik.values.landmark}
                      onChange={formik.handleChange}
                      placeholder="Near Natraj Society"
                      variant="outlined"
                      label="Landmark"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <TextField
                      name="city"
                      type="text"
                      //   margin="dense"
                      value={formik.values.city}
                      onChange={formik.handleChange}
                      placeholder="City"
                      variant="outlined"
                      label="City"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                  <div className="col-md-6 mb-3">
                    <TextField
                      name="pincode"
                      type="number"
                      //   margin="dense"
                      value={formik.values.pincode}
                      onChange={formik.handleChange}
                      placeholder="412216"
                      variant="outlined"
                      label="pincode"
                      fullWidth
                      required
                    ></TextField>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div>
                      <TextField
                        name="location"
                        type="text"
                        //   margin="dense"
                        value={formik.values.location}
                        onChange={formik.handleChange}
                        placeholder="Geo Location"
                        variant="outlined"
                        label="Organization/Institute Geo Location"
                        fullWidth
                        required
                      ></TextField>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <TextField
                        name="url1"
                        type="text"
                        //   margin="dense"
                        value={formik.values.url1}
                        onChange={formik.handleChange}
                        placeholder="Website Url"
                        variant="outlined"
                        label="Website Url"
                        fullWidth
                        required
                      ></TextField>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mt-3">
                    <FormControl fullWidth required>
                      <InputLabel id="demo-simple-select-label">
                        Year
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="category"
                        variant="outlined"
                        name="category"
                        value={formik.values.category}
                        onChange={formik.handleChange}
                        required
                      >
                        <MenuItem value="gym">Gym</MenuItem>
                        <MenuItem value="cafe">Cafe</MenuItem>
                        <MenuItem value="lodge">Lodge</MenuItem>
                        <MenuItem value="bakery">Bakery</MenuItem>

                        <MenuItem value="classes">Classes</MenuItem>
                        <MenuItem value="library">Library</MenuItem>
                        <MenuItem value="travel">Travels</MenuItem>
                        <MenuItem value="loundry">Loundry</MenuItem>
                        <MenuItem value="garage">Garage</MenuItem>
                        <MenuItem value="medical">Medical</MenuItem>
                        <MenuItem value="restaurants">Restaurants</MenuItem>
                        <MenuItem value="stationary">Stationary</MenuItem>
                        <MenuItem value="cyber_cafe">Cyber Cafe</MenuItem>
                        <MenuItem value="event_decors">Event Decors</MenuItem>
                        <MenuItem value="pg/hostels">PG/Hostels</MenuItem>

                        <MenuItem value="doctor/clinic">
                          Doctor/Clinics
                        </MenuItem>
                        <MenuItem value="mess/parcel">
                          Mess/Parcel Point
                        </MenuItem>
                        <MenuItem value="salon/parlor">Saloon/Parlor</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div className="col-md-6 mt-3">
                    <TextField
                      name="timing"
                      type="text"
                      value={formik.values.timing}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="412216"
                      variant="outlined"
                      label="Business Timing"
                      fullWidth
                      required
                    ></TextField>
                    <p className="text-danger">{formik.errors.pincode}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center">
              <Button
                className="banner text-white p-1 rounded-2 border-0 w-50"
                type="submit"
              >
                Update
              </Button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default EditShopDetails;
